<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    @click:outside="$emit('changeValue', false)"
    @keydown="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <span v-if="messages.length == 0 && !newMessagesDelivered" style="font-size: 14px">
          Carregando mensagens... por favor, aguarde.
        </span>
        <table v-else id="dialog-acompanhamento--table">
          <thead>
            <tr>
              <th style="text-align: initial">Mensagens de andamento</th>
            </tr>
          </thead>
          <tbody id="dialog-acompanhamento--t-body">
            <tr v-for="(message, i) in filteredMessages" :key="i">
              <td>{{ message }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    mixins: [pusherMixins],

    props: {
      showDialog: {
        type: Boolean,
        required: true
      },
      messages: {
        type: Array,
        required: true
      },
      nameEventPusher: {
        type: String,
        required: true
      }
    },

    emits: ['changeValue'],

    data() {
      return {
        dialog: false,
        newMessagesDelivered: false
      };
    },

    computed: {
      filteredMessages() {
        return this.messages.filter((msg) => msg.trim() != '');
      }
    },

    methods: {
      activatePusher() {
        this.newMessagesDelivered = false;

        this.pusherChannel.bind(this.nameEventPusher, (data) => {
          this.addNewRow(data.message);
        });
      },
      disablePusherEvent() {
        this.pusherChannel.unbind(this.nameEventPusher);
      },
      addNewRow(message) {
        if (!message.trim()) return;

        this.newMessagesDelivered = true;

        let tableRef = document.getElementById('dialog-acompanhamento--t-body');
        tableRef.insertRow(0).innerHTML = `<td> ${message} </td>`;
      }
    },

    watch: {
      showDialog(newValue) {
        if (newValue == false) {
          this.disablePusherEvent();
        }

        this.dialog = newValue;
      }
    }
  };
</script>

<style>
  #dialog-acompanhamento--table {
    width: 100% !important;
  }

  #dialog-acompanhamento--t-body th,
  #dialog-acompanhamento--t-body td {
    border-bottom: 1px solid rgb(211, 210, 210) !important;
    padding: 4px !important;
    text-align: justify !important;
    font-size: 14px !important;
  }
</style>
